'use strict'

import moment from 'moment'

export class DateTimeHelper {

  constructor () {
    this.dateISOFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
    this.dateYearFormat = 'YYYY-MM-DD'
    this.dateFormat = 'DD-MMM-YYYY'
    this.dateTimeFormat = 'DD-MMM-YYYY hh:mma'
    this.dateTimeUTCFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
  }

  addDaysToDate(date, num, period) {
    const convertDate = new Date(date)
    const manipulatedDate = moment(convertDate).add(num, period).toDate()
    return moment(manipulatedDate).unix()
  }

  getEpochTimeToday() {
    return moment(new Date()).unix()
  }

  getDateToday() {
    return new Date()
  }

  convertTimeObject(time) {
    const newTime = time.hh + ':' + time.mm + '' + time.a
    return newTime
  }

  convertDateToUnix(date) {
    const newDate = this.convertDate(date)
    return moment(new Date(newDate)).unix()
  }

  convertDateTimeToUnix(date, time) {
    const  newTime = time.hh + ':' + time.mm + ':' + time.ss + ' ' + time.a
    const  newDate = this.convertDate(date)
    const  newDateTime = newDate + ' ' + newTime
    const  cnvrtDateTime = moment(new Date(newDateTime)).format('DD MMM YYYY hh:mm:ss a')
    return moment(cnvrtDateTime).unix()
  }

  // birthday date formatting
  convertGMTToDateFormat(date) {
    return moment(new Date(date)).format('DD MMM YYYY')
  }

  convertUnixToDateTimeFormat(date) {
    return moment(new Date(date)).format('DD MMM YYYY hh:mma')
  }

  convertDate(date) {
    return moment(new Date(date)).format('DD MMM YYYY')
  }

  // format time from timepicker object
  convertTime(time) {
    return time.hh + ':' + time.mm + '' + time.a
  }

  // compare or check given date to date today
  compareEpochDateToday(epochA) {
    const  todayEpoch = moment(new Date()).unix()
    return this.compare(epochA, todayEpoch) !== -1
  }

  compareTwoEpochDate(epochA, epochB) {
    return this.compare(epochB, epochA) === 1
  }

  checkIfEpochIsPastMonths(epochDate) {
    // const  timestamp = new Date().getTime() + (90 * 24 * 60 * 60 * 1000)
    const  timestamp = moment(new Date()).add(3, 'months').unix()
    return this.compare(timestamp, epochDate) === 1
  }

  checkIfDateIsPastMonths(date) {
    const  newDate = this.convertDate(date)
    const  nowDate = moment(new Date()).format('DD MMM YYYY')

    const  epochDate = moment(new Date(newDate)).unix()
    const  timestamp = moment(nowDate).add(3, 'months').unix()

    return this.compare(timestamp, epochDate) === 1
  }

  compare(momentA, momentB) {
    // returns 1 if dateA is greater than dateB
    // returns 0 if dateA equals dateB
    // returns -1 if dateA is less than dateB
    if (momentA > momentB) return 1
    else if (momentA < momentB) return -1
    else return 0
  }

  convertDateToDatePickerFormat(date) {
    const  parsedDate = date.split('-')
    return parsedDate[2] + '-' + parsedDate[0] + '-' + parsedDate[1]
  }

  convertTimeToTimePickerFormat(time) {
    const  parsedTime = time.split(':')
    return {
      hh: parsedTime[0],
      mm: parsedTime[1].substring(0,2),
      ss: '00',
      a: time.slice(-2)
    }
  }

}



// WEBPACK FOOTER //
// ./src/api/helper/DateTimeHelper.js